import i18n from 'i18n';

// Señales de que un mensaje es TÉCNICO (SQL, stack traces, GraphQL interno...) y no debe
// llegar al usuario tal cual. El middleware de errores lo reemplaza por el genérico de
// errors.json en el idioma activo.
const TECHNICAL_PATTERNS = [
  /SQLSTATE/i,
  /Internal server error/i,
  /Duplicate entry/i,
  /constraint/i,
  /Exception/i,
  /undefined/i,
  /stack trace/i,
  /Trailing data/i,
  /Cannot query field/i,
  /GraphQL/i,
  /\bat line \d+/i
];

/**
 * Convierte un mensaje de error crudo en uno apto para el usuario: si huele a técnico
 * devuelve el genérico traducido; si ya es legible, lo deja pasar.
 *
 * @param {string} message mensaje crudo (payload de la action *Error)
 * @returns {string} mensaje seguro para mostrar en un toast
 */
const humanizeError = (message) => {
  const text = typeof message === 'string' ? message.trim() : '';

  if (!text) {
    return i18n.t('general.unexpected', { ns: 'errors' });
  }

  if (TECHNICAL_PATTERNS.some((pattern) => pattern.test(text))) {
    return i18n.t('general.unexpected', { ns: 'errors' });
  }

  return text;
};

export default humanizeError;
